import axios from 'axios';

export const createCampaign = async (campaignData) => {
  try {
    const response = await axios.post(`${import.meta.env.VITE_API_URL_DASHBOARD_URL}/campaign`, campaignData);
    return response.data;
  } catch (error) {
    console.error("There was an error creating the campaign!", error);
    throw error;
  }
};
